import { defineComponent as p, computed as f } from "vue";
const l = /* @__PURE__ */ p({
  __name: "heading",
  props: {
    align: { default: void 0 },
    size: { default: "" },
    theme: { default: void 0 },
    tag: { default: "h1" },
    fontWeight: { default: "bold" },
    text: { default: "" },
    textUppercase: { type: Boolean, default: !1 },
    spacesTop: { type: Boolean, default: !1 },
    spacesBottom: { type: Boolean, default: !1 },
    spacesTopRem: { type: Boolean, default: !1 },
    spacesBottomRem: { type: Boolean, default: !1 },
    itemprop: { default: void 0 }
  },
  setup(a) {
    const e = a, s = {
      xxl: "h1",
      xl: "h2",
      lg: "h3",
      md: "h4",
      sm: "h5",
      xs: "h6"
    }, o = f(() => {
      const t = [];
      return e.spacesTop && t.push("heading--spaces-top"), e.spacesBottom && t.push("heading--spaces-bottom"), e.spacesTopRem && t.push("heading--spaces-top-rem"), e.spacesBottomRem && t.push("heading--spaces-bottom-rem"), e.theme && t.push(`text--${e.theme}`), e.align && t.push(`text--${e.align}`), t.push(`text--${e.size ? s[e.size] : e.tag}`), e.fontWeight && t.push(`text--${e.fontWeight}`), e.textUppercase && t.push("text--uppercase"), t;
    });
    return { __sfc: !0, props: e, placeholderHeadingSizes: s, classes: o };
  }
});
export {
  l as default
};
